var map = {
	"./HomeView.vue": [
		7405,
		405
	],
	"./Page/AboutView.vue": [
		7043,
		594
	],
	"./Page/AccidentView.vue": [
		5233,
		100
	],
	"./Page/ArticleView.vue": [
		5526,
		275
	],
	"./Page/BreakingNewsView.vue": [
		2604,
		365
	],
	"./Page/CaricatureView.vue": [
		703,
		862
	],
	"./Page/ContactView.vue": [
		9397,
		353
	],
	"./Page/EconomieView.vue": [
		8484,
		386
	],
	"./Page/HealthView.vue": [
		9973,
		77
	],
	"./Page/InfographicView.vue": [
		8712,
		521
	],
	"./Page/InternationalRegionalView.vue": [
		6920,
		818
	],
	"./Page/MixView.vue": [
		2738,
		899
	],
	"./Page/NewsView.vue": [
		7179,
		946
	],
	"./Page/NotFoundView.vue": [
		8397
	],
	"./Page/PolicyView.vue": [
		17,
		477
	],
	"./Page/PressView.vue": [
		1977,
		68
	],
	"./Page/ReadArticleView.vue": [
		5787,
		19
	],
	"./Page/SportView.vue": [
		7805,
		823
	],
	"./Page/TechnologyView.vue": [
		7109,
		509
	],
	"./Page/VideoPlay.vue": [
		1535,
		98
	],
	"./Page/VideoView.vue": [
		4145,
		180
	],
	"./Page/WellcomeView.vue": [
		7589,
		719
	],
	"./User/LoginUserView.vue": [
		8903,
		399
	],
	"./User/UnsubscribeView.vue": [
		1202,
		922
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4235;
module.exports = webpackAsyncContext;